import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Tag, Icon, Input, Button, Popconfirm } from 'antd'

import { isObjEmpty } from '@utils/index'

import AddKeywords from '../AddKeywords'

@inject((store: any) => {
    const { synonymsStore } = store
    return { synonymsStore }
})
@observer
class Item extends Component<any, any> {
    state = {
        edit: {},
        edited: false,
        hover: false,
        error: null
    }
    toggleKeywordsEdit = id => {
        this.props.synonymsStore.toggleKeywordsEdit(id)
        this.setState({ error: null })
    }
    handleItemHover = hover => {
        this.setState({ hover })
    }
    handleChangeValue = (name, value) => {
        const edit = { ...this.state.edit }
        const newValue = !!value ? value : null
        if ((name === 'weight' && newValue < 21 && newValue > 0) || name !== 'weight') {
            if (name in edit && this.props.synonymItem[name] === newValue) {
                delete edit[name]
            } else {
                edit[name] = newValue
            }
            const edited = isObjEmpty(edit)
            this.setState({ edit, edited })
        }
    }
    handleUpdateGroup = async () => {
        const { edit } = this.state
        const { synonymItem, synonymsStore } = this.props
        synonymsStore
            .updateSynonym({ ...synonymItem, ...edit })
            .then(async res => {
                await synonymsStore.getSynonymsList()
                await synonymsStore.applyFilters()
                this.handleCancelEdit()
            })
            .catch(e => {
                if (e.response.status === 403) {
                    this.setState({ error: 'שם הקבוצה או מושג בקבוצה כבר קיים' })
                } else {
                    this.setState({ error: 'קיימת שגיאה בשמירת הנתונים בשרת' })
                }
            })
    }
    handleAddGroup = async () => {
        const { edit } = this.state
        const { synonymsStore } = this.props
        synonymsStore
            .addSynonymGroup({ ...edit })
            .then(async res => {
                await synonymsStore.getSynonymsList()
                await synonymsStore.applyFilters()
                this.handleCancelEdit()
            })
            .catch(e => {
                if (e.response.status === 403) {
                    this.setState({ error: 'שם הקבוצה או מושג בקבוצה כבר קיים' })
                } else {
                    this.setState({ error: 'קיימת שגיאה בשמירת הנתונים בשרת' })
                }
            })
    }
    handleCancelEdit = () => {
        this.setState({ edit: {}, edited: false, error: null })
    }
    render() {
        const {
            keywordsEdit,
            toggleKeywordsEdit,
            removeKeyword,
            removeSynonymGroup,
            pendingKeywords
        } = this.props.synonymsStore
        const { edit, edited, hover, error } = this.state
        const { name, keywords, weight, id } = this.props.synonymItem
        const groupName = 'name' in edit ? edit['name'] : name
        const groupWeight = 'weight' in edit ? edit['weight'] : weight
        let backgroundColor = 'white'
        if (edited && id !== 'ADD') {
            backgroundColor = '#e4e4e4'
        } else if (hover || keywordsEdit === id) {
            backgroundColor = '#ffeed5'
        }

        let keywordsList = ''
        if (keywords) {
            keywordsList = keywords.split(',').map((keyword, index) => {
                return (
                    <Tag key={index} style={{ margin: '0.3rem' }}>
                        <Popconfirm
                            title="האם אתה בטוח שברצונך להסיר מושג זה?"
                            onConfirm={() => removeKeyword({ ...this.props.synonymItem, keyword })}
                        >
                            <Icon type="close" />
                        </Popconfirm>
                        {keyword.replace('_', ' ')}
                    </Tag>
                )
            })
        } else if (id !== 'ADD') {
            keywordsList = 'לא נמצאו מושגים בקבוצה'
        }

        return (
            <div
                onMouseEnter={() => this.handleItemHover(true)}
                onMouseLeave={() => this.handleItemHover(false)}
                style={{ padding: '0.4rem', position: 'relative', display: 'flex', width: '100%', backgroundColor }}
            >
                <div style={{ width: '22.5%', paddingLeft: '0.5rem', display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: '20%' }}>
                        <Input
                            style={{ padding: '0.2rem' }}
                            min={1}
                            max={20}
                            type="number"
                            placeholder="משקל"
                            value={groupWeight}
                            onChange={e => this.handleChangeValue('weight', parseFloat(e.target.value))}
                        />
                    </div>
                    <div style={{ width: '80%', paddingRight: '0.5rem' }}>
                        <Input
                            style={{ border: `${hover ? 'initial' : 'none'}`, fontWeight: 'bold' }}
                            placeholder="קבוצה ללא שם"
                            value={groupName}
                            onChange={e => this.handleChangeValue('name', e.target.value)}
                        />
                    </div>
                </div>
                <div style={{ width: '75%' }}>
                    {edited && id !== 'ADD' ? (
                        <Fragment>
                            <div>
                                <Button onClick={() => this.handleCancelEdit()}>
                                    <Icon type="stop" /> ביטול
                                </Button>
                                <Button type="primary" onClick={() => this.handleUpdateGroup()}>
                                    <Icon type="check" /> שמור שינויים
                                </Button>
                            </div>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <div>
                                {keywordsList}
                                {hover && keywordsEdit !== id && (
                                    <Button
                                        onClick={() => {
                                            this.toggleKeywordsEdit(id)
                                        }}
                                        size="small"
                                        type="dashed"
                                        style={{
                                            fontSize: '0.8rem',
                                            background: 'none',
                                            borderColor: 'gray',
                                            height: '1.5rem',
                                            margin: '0 0.3rem'
                                        }}
                                    >
                                        הוסף מושגים +
                                    </Button>
                                )}
                                {hover && !keywordsEdit && pendingKeywords.length > 0 && (
                                    <Button
                                        size="small"
                                        style={{ fontSize: '0.8rem', height: '1.5rem', margin: '0 0.3rem' }}
                                        type="primary"
                                        onClick={() => {
                                            toggleKeywordsEdit(id)
                                            this.handleUpdateGroup()
                                        }}
                                    >
                                        <Icon type="check" /> הוסף ושמור
                                    </Button>
                                )}
                            </div>
                        </Fragment>
                    )}
                    {!!(keywordsEdit === id) && <AddKeywords {...this.props.synonymItem} />}
                    <div>{error && <div style={{ width: '100%', color: 'red', fontWeight: 500 }}>{error}</div>}</div>
                </div>
                {
                    <div style={{ width: '5%', textAlign: 'center' }}>
                        {hover && id !== 'ADD' ? (
                            <Popconfirm
                                title="האם להסיר את קבוצת המושגים?"
                                okText="הסר"
                                cancelText="בטל"
                                onConfirm={() => removeSynonymGroup(id)}
                            >
                                <Button style={{ width: '100%' }}>
                                    <Icon type="delete" />
                                </Button>
                            </Popconfirm>
                        ) : (
                            id === 'ADD' && (
                                <Button type="primary" onClick={() => this.handleAddGroup()}>
                                    <Icon type="check" />
                                </Button>
                            )
                        )}
                    </div>
                }
            </div>
        )
    }
}

export default withRouter(Item)
